<template>
    <div class="">
        <input type="hidden" name="search" :value="JSON.stringify(search)">

        <div class="row">
            <div class="col">
                <div class="card shadow mb-3">
                    <div class="card-header py-3">
                        <h6 class="m-0 font-weight-bold text-primary">Filter</h6>
                    </div>
                    <div class="card-body">

                        <div class="form-group">
                            <label>Produktname</label>
                            <input type="text" class="form-control" placeholder="Name" v-model="search.name">
                        </div>

                        <div class="form-group">
                            <label>Vertriebsstatus</label>
                            <select class="form-control" v-model="search.vertrieb">
                                <option :value="-1">Alle</option>
                                <option :value="0">keine Angabe</option>
                                <option :value="1">außer Vertrieb</option>
                                <option :value="2">im Vertrieb</option>
                                <option :value="3">zurückgezogen</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Artikeltyp</label>
                            <select class="form-control" v-model="search.typ">
                                <option :value="-1">Alle</option>
                                <option :value="1">Standard</option>
                                <option :value="2">Klinikartikel</option>
                                <option :value="3">Pandemieartikel</option>
                                <option :value="5">Schüttware</option>
                                <option :value="6">Muster</option>
                                <option :value="7">Marketingbedarf</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>
                                Preis
                            </label>
                            <div class="row">
                                <div class="col">
                                    <select class="form-control" v-model="search.preisFilter">
                                        <option value="all">Alle</option>
                                        <option value="ek">Apo EK</option>
                                        <option value="vk">Apo VK</option>
                                        <option value="uvp">UVP</option>
                                    </select>
                                </div>
                                <div class="col" v-if="search.preisFilter !== 'all'">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Min €</span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="0" v-model="search.preisMin">
                                    </div>
                                </div>
                                <div class="col" v-if="search.preisFilter !== 'all'">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Max €</span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="0" v-model="search.preisMax">
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <filtering-module :dto="search.filtering"
                                  :pharmacies="false"
                                  :warengruppen="true"
                                  :warengruppenWirkstoffeOr="false"
                                  :wirkstoffe="true"
                                  :dar="true"
                                  :menge="true"
                                  :reimport="true"
                                  :options="options"></filtering-module>
            </div>
        </div>

        <pre v-if="$debugEnabled">{{ JSON.stringify(search, 0, 2) }}</pre>
    </div>
</template>

<script>

import FilteringModule from "./Modules/FilteringModule.vue";

export default {
    components: {FilteringModule},
    props: {
        searchModel: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        hidden: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            search: this.searchModel,
        };
    },
    methods: {},
    computed: {},
}
</script>
